import client from '../http_client';
import { AccessResponse } from './types';

const root = '/v1/profile';

export class ProfileService {
  public static async access(): Promise<AccessResponse> {
    const response = await client.get<AccessResponse>(`${root}/access`);
    return response.data;
  }
}
